module.exports = __webpack_public_path__ + "fonts/OpenSans300.67934de2.eot";